/**
 * BulkResyncHeader — top action bar for BulkResyncPanel.
 * Controls: "only active" checkbox + run button.
 */
import React from 'react';
import { Zap, RotateCw } from 'lucide-react';
import { useT } from '../../i18n/I18nContext.jsx';

export function BulkResyncHeader({ running, onlyActive, onToggleActive, onRun }) {
  const t = useT();
  return (
    <div className="card-header">
      <div>
        <div className="card-title">{t('erp.bulkResync.title', 'Bulk Re-sync Orchestration')}</div>
        <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 2 }}>
          {t('erp.bulkResync.subtitle',
            'Push the latest Tier Privileges to RC26erp_dev AND pre-compute the personalized tier-config payload for every licensed client.'
          )}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'var(--text-secondary)', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={onlyActive}
            onChange={e => onToggleActive(e.target.checked)}
            data-testid="bulk-resync-active-only"
          />
          {t('erp.bulkResync.onlyActive', 'Only active licenses')}
        </label>
        <button
          className="btn btn-primary"
          onClick={onRun}
          disabled={running}
          data-testid="bulk-resync-run"
          style={{ background: running ? '#94a3b8' : '#f59e0b' }}
        >
          {running
            ? <><RotateCw size={13} className="spin" /> {t('erp.bulkResync.running', 'Running…')}</>
            : <><Zap size={13} /> {t('erp.bulkResync.runBtn', 'Re-sync All Clients')}</>}
        </button>
      </div>
    </div>
  );
}
